import React from 'react';
import grammar from '~constants/grammar';
import { HeadingText, ActionText, WomanImg } from './styledComponents';

type Props = {
  offersLength: number;
};

const QuizHeading = ({ offersLength }: Props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'flexStart' }}>
      <WomanImg />
      <div>
        <HeadingText>
          Результаты подбора:{' '}
          <span>
            {offersLength} {grammar.offer(offersLength)}{' '}
          </span>
        </HeadingText>
        <ActionText>
          Оставьте ваши контакты, чтобы посмотреть предложения
        </ActionText>
      </div>
    </div>
  );
};

export default QuizHeading;
